module.exports = __webpack_public_path__ + "img/20241205.a1578e8f.png";